// extracted by mini-css-extract-plugin
export default {"commentBox":"CreateIssueForm-module__commentBox--yWrlH","errorBanner":"CreateIssueForm-module__errorBanner--qrYq_","footerButton":"CreateIssueForm-module__footerButton--5fjDi"};